import * as React from "react";
const SvgFiRrMeat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meat_svg__a)">
      <path
        fill="#062147"
        d="M21.03 2.98C17.831-.219 13.556-.959 11.3 1.298 8.202 4.396 6.424 8.5 6.014 13.496a4.16 4.16 0 0 0 .581 2.494l-3.783 3.784a1.5 1.5 0 1 0-.666 2.081 1.5 1.5 0 1 0 2.08-.666l3.783-3.784a4.16 4.16 0 0 0 2.494.582c5.011-.411 9.119-2.187 12.208-5.276 2.256-2.256 1.518-6.53-1.682-9.73zm-1.414 1.414c2.326 2.327 3.097 5.487 1.682 6.902-1.414 1.415-4.575.644-6.902-1.683-1.198-1.198-2.011-2.618-2.29-3.998-.25-1.231-.033-2.263.608-2.904.481-.481 1.165-.709 1.949-.709 1.52 0 3.418.858 4.953 2.392m-9.275 11.598a2.13 2.13 0 0 1-1.71-.623 2.16 2.16 0 0 1-.623-1.709c.234-2.854.954-5.375 2.148-7.541.36 1.659 1.321 3.403 2.826 4.908s3.245 2.464 4.903 2.825c-2.163 1.188-4.686 1.906-7.544 2.14M16.28 7.73c-.725-.725-.988-1.637-.587-2.038s1.313-.138 2.038.587.988 1.637.587 2.038-1.313.138-2.038-.587"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeat;
